import { all } from 'redux-saga/effects';
import { downloadCdrSaga, getRecordsSaga } from './records.action';

export { getRecords, downloadCdr } from './records.action';
export { default as recordsReducer } from './records.reducer';

export const recordsSaga = function* () {
  yield all([getRecordsSaga(), downloadCdrSaga()]);
};
